import { useAuth } from '@/auth/hyper-auth'

const overrideConfig = {
    baseURL: process.env.VUE_APP_AUTH_URL,
    namespace: process.env.VUE_APP_NAMESPACE,
    serviceGroup: process.env.VUE_APP_SERVICE,
    specificAuthKeyName: 'hyper-auth'
}

const service = {
    memberSignin ({ email, password }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.post(`/auth/login/${process.env.VUE_APP_SERVICE}`, { email, password })
    },
    memberSigninOtp ({ otpCode }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.post(`/auth/login/otp/${process.env.VUE_APP_SERVICE}`, { otpCode })
    },
    memberSignout ({ id }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.delete(`/auth/logout/${process.env.VUE_APP_SERVICE}/id/${id}`)
    },
    tokenSignin ({ email }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.post(`/auth/login/internal/${process.env.VUE_APP_SERVICE}`, { email })
    },
    tokenSigninAdmin ({ email, adminIdx, userIdx }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.post(`/auth/login/admin/${process.env.VUE_APP_SERVICE}`, { email, adminIdx, userIdx })
    },
    memberSigninAgain ({ email }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.post('/auth/login/internal/auth-center', { email })
    }
}

export {
    service,
    overrideConfig,
    useAuth
}
